import React from "react";
import { Add } from "iconsax-react";
import { Modal } from "../SharedComponents";
import { ModalNames } from "../../Constants/modalNames";
import { useModal } from "../../Store/modules/modal/modal";
import { useLanguage } from "../../Store/modules/language";
import { useTheme } from "../../Store/modules/theme";
import { Div, Icon, Text } from "../Kit";
import { Button } from "../Kit/Button";
import { useAgencyRawDataDelete } from "../../Store/modules/bots/agencyRawDataDelete/agencyRawDataDelete";
import settings from "../../settings/settings";

export const DeleteKnowledgeModal: React.FC = () => {
  const { direction } = useLanguage();
  const { name: themeStatus } = useTheme();
  const { modalProps, dispatchCloseModal } = useModal();
  const { id, agencyId } = modalProps || {};
  const { dispatchAgencyRawDataDelete, agencyRawDataDeleteLoading } =
    useAgencyRawDataDelete();

  const onConfirm = () => {
    if (!id || !agencyId || agencyRawDataDeleteLoading) return;
    dispatchAgencyRawDataDelete({ id, agencyId });
  };

  return (
    <Modal
      modalName={ModalNames.DeleteKnowledgeModal}
      modalClassName="rounded-[10px] relative w-[327px] flex flex-col justify-between items-center"
    >
      <Div
        dir={direction}
        bg="forthOpt"
        className="w-[27px] h-[27px] flex items-center justify-center pointer rounded-[50%] absolute right-[10px] top-[10px]"
        onClick={() => dispatchCloseModal()}
      >
        <Icon Component={Add} size={20} className="rotate-[45deg]" color="text" />
      </Div>

      <div className="py-5 mt-4 text-start">
        <Text elementType="span" className="text-sm">
          agencyCreate.deleteKnowledgeConfirm
        </Text>
      </div>

      <div className="flex flex-row items-center justify-center gap-2 w-full">
        <Button
          title="delete"
          className="w-full h-[40px] flex-[2]"
          textClassName="text-sm"
          loading={agencyRawDataDeleteLoading}
          bg="error"
          onClick={onConfirm}
        />
        <Button
          title="cancel"
          bg="transparent"
          borderWidth="1px"
          borderColor="primary"
          borderStyle="solid"
          textColor="primary"
          textClassName="text-sm"
          className="w-full h-[40px] flex-[1]"
          onClick={dispatchCloseModal}
        />
      </div>
    </Modal>
  );
};